import { IStepDto } from './create-trip-input-dto.interface';

export interface IBulkUpdateStepPropsDto {
    /** Target by identity; falls back to `checkpointIndex` when absent. */
    checkpointId?: string;
    checkpointIndex: number;
    stepIndex: number;
    estimatedAt: string;
    data?: IStepDto;
}

export interface IBulkUpdateStepsDto {
    tripId: string;
    steps: IBulkUpdateStepPropsDto[];
}
